const timestamp = (item) => {
  const value = Date.parse(item?.listened_at || "");
  return Number.isFinite(value) ? value : 0;
};

export const selectPreferredGuides = (history, preferredLanguage = "en") => {
  const byPlace = new Map();
  for (const item of history || []) {
    if (!item?.place_id) continue;
    const current = byPlace.get(item.place_id);
    const itemPreferred = (item.language || "en") === preferredLanguage;
    const currentPreferred = (current?.language || "en") === preferredLanguage;
    if (
      !current ||
      (itemPreferred && !currentPreferred) ||
      (itemPreferred === currentPreferred && timestamp(item) > timestamp(current))
    ) {
      byPlace.set(item.place_id, item);
    }
  }
  return Array.from(byPlace.values());
};

export const sortGuides = (guides, mode = "newest", ascending = false) => {
  const items = [...(guides || [])];
  items.sort((a, b) => {
    let comparison = 0;
    if (mode === "alpha") {
      comparison = (a.place_name || "").localeCompare(b.place_name || "", undefined, {
        sensitivity: "base",
      });
    } else if (mode === "rating") {
      comparison = (a.user_rating || 0) - (b.user_rating || 0);
    } else {
      comparison = timestamp(a) - timestamp(b);
    }
    if (comparison === 0) {
      comparison = (a.place_name || "").localeCompare(b.place_name || "", undefined, {
        sensitivity: "base",
      });
    }
    return ascending ? comparison : -comparison;
  });
  return items;
};
